import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=61b12ce5&scoped=true&"
import script from "./TaskBoard.vue?vue&type=script&lang=js&"
export * from "./TaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&id=61b12ce5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b12ce5",
  null
  
)

export default component.exports